import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChangeLastpasswordComponent } from './change-lastpassword.component';
import { RouterModule, Routes } from '@angular/router';
import { PublicSharedModule } from 'src/app/public-website/public-shared/public-shared.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
const changeLastPassword: Routes = [
  { path: '', component: ChangeLastpasswordComponent },
];

@NgModule({
  declarations: [ChangeLastpasswordComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(changeLastPassword),
    SharedModule,
    PublicSharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class ChangePasswordModule {}
